// This keeps two-thirds of the previous 64:21 title-crop height at the same width.
export const TITLE_ASPECT_RATIO = 32 / 7;
export const DEFAULT_CROP_POSITION = { x: 50, y: 50 };

export interface CropPosition {
  x: number;
  y: number;
}

export interface CropRect {
  height: number;
  left: number;
  maxX: number;
  maxY: number;
  top: number;
  width: number;
}

interface Size {
  height: number;
  width: number;
}

export function clampCropPosition(value: number): number {
  return Math.min(100, Math.max(0, value));
}

export function getTitleCropRect(
  size: Size,
  position: CropPosition
): CropRect {
  if (size.width === 0 || size.height === 0) {
    return {
      height: 0,
      left: 0,
      maxX: 0,
      maxY: 0,
      top: 0,
      width: 0,
    };
  }

  if (size.width / size.height > TITLE_ASPECT_RATIO) {
    const width = size.height * TITLE_ASPECT_RATIO;
    const maxX = size.width - width;

    return {
      height: size.height,
      left: (maxX * position.x) / 100,
      maxX,
      maxY: 0,
      top: 0,
      width,
    };
  }

  const height = size.width / TITLE_ASPECT_RATIO;
  const maxY = size.height - height;

  return {
    height,
    left: 0,
    maxX: 0,
    maxY,
    top: (maxY * position.y) / 100,
    width: size.width,
  };
}
